import Card from './Card'
import PaymentForm from './PaymentForm'
import BuyCards from './BuyCards'
import CheckBalance from './CheckBalance'
import ProductPaymentForm from './ProductPaymentForm'
import Playcards from './Playcards'
import AddPlaycardButton from './AddPlaycardButton'
import AddProductButton from './AddProductButton'
import ReloadCard from './ReloadCard'
import ReloadCardInitForm from './ReloadCardInitForm'
import RegisterCard from './RegisterCard'
import ClaimVoucher from './ClaimVoucher'

Vue.component(Card.name, Card)
Vue.component(PaymentForm.name, PaymentForm)
Vue.component(BuyCards.name, BuyCards)
Vue.component(CheckBalance.name, CheckBalance)
Vue.component(ProductPaymentForm.name, ProductPaymentForm)
Vue.component(Playcards.name, Playcards)
Vue.component(AddPlaycardButton.name, AddPlaycardButton)
Vue.component(AddProductButton.name, AddProductButton)
Vue.component(ReloadCard.name, ReloadCard)
Vue.component(ReloadCardInitForm.name, ReloadCardInitForm)
Vue.component(RegisterCard.name, RegisterCard)
Vue.component(ClaimVoucher.name, ClaimVoucher)

import './new-user-promotion'
import './what-is-this'
import './user-input'

export default {Card, PaymentForm, BuyCards, CheckBalance, ProductPaymentForm, Playcards, AddPlaycardButton, AddProductButton, ReloadCard, ReloadCardInitForm, RegisterCard, ClaimVoucher}
